module.exports = __webpack_public_path__ + "img/selo.917b5806.png";